import * as R from "constants/userRights";
import { useEffect, useState } from "react";
import { useQueryWithErrorHandling } from "./errorHandling";
const { useApolloClient } = require("@apollo/client");
const { emptyObject, emptyArray } = require("constants/defaultValues");
const { USER_DATA } = require("features/common/queries");

const useUserData = () => {
  const client = useApolloClient();

  const { data } = useQueryWithErrorHandling(USER_DATA, { fetchPolicy: "cache-only" });
  const cacheUserData = data?.userData || {
    isInternalUser: false,
    showQuestionsInVCP: false,
    allowAutomatedDecision: false,
    isExchangeRateFunctionality: false,
    showDecisionReasons: false,
    dealerDrivenConsent: false,
    customerDrivenConsent: false,
    requestAlwaysConsent: false,
    allowSoleTraderSearch: false,
    allowInsurance: false,
    allowSelectionInsuranceConvention: false,
    useDownloadProductInStep4: false,
    rights: emptyArray,
    userRights: {
      hasUserRight: false,
      hasDealerAdminUserRight: false,
      hasAdminUserRight: false,
      hasEstimatorOnlyRight: false,
      hasVendorAdminUserRight: false,
    },
  };

  const [userData, setUserData] = useState(cacheUserData);

  useEffect(() => {
    const sub = client.watchQuery({ query: USER_DATA, fetchPolicy: "cache-only" }).subscribe({
      next: ({ data }) => {
        const userData = data?.userData || emptyObject;
        const userRights = userData?.rights && {
          hasUserRight: Boolean(userData.rights.find((x) => x === R.userRights.user.code)),
          hasDealerAdminUserRight: Boolean(userData.rights.find((x) => x === R.userRights.dealerAdminUser.code)),
          hasAdminUserRight: Boolean(userData.rights.find((x) => x === R.userRights.adminUser.code)),
          hasEstimatorOnlyRight: Boolean(userData.rights.find((x) => x === R.userRights.estimatorOnly.code)),
          hasVendorAdminUserRight: Boolean(userData.rights.find((x) => x === R.userRights.vendorAdmin.code)),
        };
        setUserData({ ...userData, userRights: userRights || emptyArray });
      },
    });
    return () => sub.unsubscribe();
  }, [client]);

  return userData;
};

export default useUserData;
